import { duration, ScreenshotClocks } from '@shared';

export const currentVideoTime = (start: number, end: number, played: number) => {
  return start + duration(start, end) * played;
};
export const getScreenshotByTime = (screenshotsClock: ScreenshotClocks, currentTime: number) => {
  const firstScreenshot = screenshotsClock[0];

  if (currentTime < Number(firstScreenshot.clock)) {
    return firstScreenshot;
  }

  const screenshotIndex = screenshotsClock.findIndex((screenshot) => {
    return Number(screenshot.clock) > currentTime;
  });

  if (screenshotIndex === -1) {
    return screenshotsClock[screenshotsClock.length - 1];
  }
  const previousScreenshotIndex = screenshotIndex - 1;
  return screenshotsClock[previousScreenshotIndex];
};
